/**
 * Cognito JWT per tenant (INTERFACES.md section 3: "Cognito JWT per
 * tenant"). SC3 owns the capture client only, not auth, so this module
 * defines the seam a future auth packet fills: set the token once after
 * sign-in, every request in src/lib/api reads it from here.
 *
 * D2 fills that seam. `src/components/auth/AuthProvider.tsx` calls
 * `setAuthToken` with the Cognito ID token after sign-in and after every
 * refresh, and registers an unauthorized handler so a 401 gets one refresh
 * attempt before the operator is sent back to sign-in.
 */

let authToken: string | null = null;

export function setAuthToken(token: string | null): void {
  authToken = token;
}

export function getAuthToken(): string | null {
  return authToken;
}

/** Called by `request` on a 401. Returns a fresh token to retry with, or
 * null when the session is unrecoverable. Registered once by the auth
 * provider: `src/lib/api` knows nothing about Cognito. */
export type UnauthorizedHandler = () => Promise<string | null>;

let unauthorizedHandler: UnauthorizedHandler | null = null;

export function setUnauthorizedHandler(handler: UnauthorizedHandler | null): void {
  unauthorizedHandler = handler;
}

export function getUnauthorizedHandler(): UnauthorizedHandler | null {
  return unauthorizedHandler;
}

export function getCaptureApiBaseUrl(): string {
  return import.meta.env.VITE_CAPTURE_API_URL ?? '/capture-api';
}
